var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import * as Either from "fp-ts/lib/Either";
import { Env, Result, content } from "core/utils";
import { TvGuide } from "pages/tvguide/View";
import { getOwnTvGuideData } from "pages/tvguide/api";
import { isCacheMiss } from "./data";
import { Tracking } from "core/tracking";
export var prepProvider = function (headController) {
    return function (_a) {
        var appState = _a.appState, slug = _a.slug, Loading = _a.Loading, Error = _a.Error;
        var dataFromCache = getDataFromCache(appState.pageCache, slug);
        var _b = useState(dataFromCache), result = _b[0], setResult = _b[1];
        if (Env.isServer && result.kind === "Success") {
            headController.includeCss(result.value.css[0]);
        }
        useEffect(function () {
            Tracking.trackStaticPage({
                title: content.tvGuide.tracking.title,
                type: content.tvGuide.tracking.type,
            });
        }, []);
        useEffect(function () {
            if (isCacheMiss(result) && Env.isClient) {
                setResult(Result.loading);
                /**
                 * IIFE for async await
                 */
                (function () { return __awaiter(void 0, void 0, Promise, function () {
                    var either, epgData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getOwnTvGuideData(origin, slug)];
                            case 1:
                                either = _a.sent();
                                if (!Either.isRight(either)) return [3 /*break*/, 3];
                                epgData = either.right;
                                return [4 /*yield*/, Promise.all(epgData.css.map(function (cssUrl) { return headController.includeCss(cssUrl); }))];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                setResult(Result.fromEither(either));
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
        }, []);
        if (isCacheMiss(result))
            return React.createElement(Loading, null);
        return Result.fold({
            onLoading: function () { return React.createElement(Loading, null); },
            onFail: function (error) { return React.createElement(Error, { error: error }); },
            onSuccess: function (payload) { return (React.createElement(TvGuide, { origin: appState.origin, data: payload })); },
        })(result);
    };
};
function getDataFromCache(cache, slug) {
    if (cache.epgCache === null)
        return { kind: "CacheEmpty" };
    if (cache.epgCache.slug !== slug)
        return { kind: "NoMatchingSlug" };
    return Result.fromEither(cache.epgCache.data);
}
